"use strict";

var _regeneratorRuntime = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HttpClient = void 0;

var http_request_1 = require("./http-request");

var web_fetcher_1 = require("./fetchers/web.fetcher");

var HttpClient = /*#__PURE__*/function () {
  function HttpClient() {
    _classCallCheck(this, HttpClient);

    this.interceptors = [];
    this.fetcher = new web_fetcher_1.WebFetcher();
  }
  /**
   * Registers a new interceptor to this http client instance.
   * @param interceptor An interceptor
   */


  _createClass(HttpClient, [{
    key: "registerInterceptor",
    value: function registerInterceptor(interceptor) {
      if (!interceptor) throw new Error("The interceptor can not be null or undefined.");
      this.interceptors.push(interceptor);
    }
    /**
     * Registers an array of interceptors to this http client instance.
     * @param interceptors An array of interceptors.
     */

  }, {
    key: "registerInterceptors",
    value: function registerInterceptors(interceptors) {
      var _this = this;

      interceptors.forEach(function (x) {
        return _this.registerInterceptor(x);
      });
    }
    /**
     * Removes an interceptor from the interceptor collection.
     * @param interceptor Interceptor to be removed.
     */

  }, {
    key: "removeInterceptor",
    value: function removeInterceptor(interceptor) {
      var index = this.interceptors.indexOf(interceptor);
      if (index < 0) throw new Error("The interceptor does not belong to the http client and can not be removed.");
      this.interceptors.splice(index, 1);
    }
    /**
     * Checks if a given interceptor instance is registered.
     * @param interceptor Interceptor instance.
     */

  }, {
    key: "isRegistered",
    value: function isRegistered(interceptor) {
      return this.interceptors.indexOf(interceptor) >= 0;
    }
    /**
     * Sets the main fetcher.
     * A fetcher is in charge of making the actual request.
     * By default the http client will try to use the web implementation.
     * If running this library in a non-web context, like node, you should
     * implement a different fetcher, with node-fetch.
     * @param fetcher A fetcher instance
     */

  }, {
    key: "setFetcher",
    value: function setFetcher(fetcher) {
      this.fetcher = fetcher;
    }
    /**
     * Sends a http request, and prepares the request and response with the registered interceptors.
     * @param request The http request.
     */

  }, {
    key: "request",
    value: function request(_request) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var pipedRequest, i, interceptor, pipedResponse, _i, _interceptor;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_request) {
                  _context.next = 2;
                  break;
                }

                throw new Error("The request can not be null or undefined.");

              case 2:
                pipedRequest = _request; // iterates over the interceptors and prepares the request.

                i = 0;

              case 4:
                if (!(i < this.interceptors.length)) {
                  _context.next = 13;
                  break;
                }

                interceptor = this.interceptors[i];

                if (!interceptor.beforeSend) {
                  _context.next = 10;
                  break;
                }

                _context.next = 9;
                return interceptor.beforeSend(pipedRequest);

              case 9:
                pipedRequest = _context.sent;

              case 10:
                i++;
                _context.next = 4;
                break;

              case 13:
                _context.next = 15;
                return this.fetcher.fetch(pipedRequest);

              case 15:
                pipedResponse = _context.sent;
                _i = this.interceptors.length - 1;

              case 17:
                if (!(_i >= 0)) {
                  _context.next = 26;
                  break;
                }

                _interceptor = this.interceptors[_i];

                if (!_interceptor.afterReceive) {
                  _context.next = 23;
                  break;
                }

                _context.next = 22;
                return _interceptor.afterReceive(pipedResponse);

              case 22:
                pipedResponse = _context.sent;

              case 23:
                _i--;
                _context.next = 17;
                break;

              case 26:
                return _context.abrupt("return", pipedResponse);

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "get",
    value: function get(url, queryString) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var request;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                request = new http_request_1.HttpRequest(this.getUrl(url, queryString));
                request.method = 'GET';
                _context2.next = 4;
                return this.request(request);

              case 4:
                return _context2.abrupt("return", _context2.sent);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "post",
    value: function post(url, queryString, body) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var request;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                request = new http_request_1.HttpRequest(this.getUrl(url, queryString));
                request.method = 'POST';
                request.body = body;
                _context3.next = 5;
                return this.request(request);

              case 5:
                return _context3.abrupt("return", _context3.sent);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "put",
    value: function put(url, queryString, body) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var request;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                request = new http_request_1.HttpRequest(this.getUrl(url, queryString));
                request.method = 'PUT';
                request.body = body;
                _context4.next = 5;
                return this.request(request);

              case 5:
                return _context4.abrupt("return", _context4.sent);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "patch",
    value: function patch(url, queryString, body) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var request;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                request = new http_request_1.HttpRequest(this.getUrl(url, queryString));
                request.method = 'PATCH';
                request.body = body;
                _context5.next = 5;
                return this.request(request);

              case 5:
                return _context5.abrupt("return", _context5.sent);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "delete",
    value: function _delete(url, queryString) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var request;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                request = new http_request_1.HttpRequest(this.getUrl(url, queryString));
                request.method = 'DELETE';
                _context6.next = 4;
                return this.request(request);

              case 4:
                return _context6.abrupt("return", _context6.sent);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "getUrl",
    value: function getUrl(url, queryString) {
      if (!queryString) return url;

      for (var key in queryString) {
        var value = this.getStringValue(queryString[key]);
        if (value === null) throw new Error("The query string parameter '".concat(key, "' is undefined or an invalid object type."));
        url = url.replace("{".concat(key, "}"), value);
      }

      return url;
    }
  }, {
    key: "getStringValue",
    value: function getStringValue(value) {
      if (value === null || value === undefined) {
        return null;
      }

      if (typeof value === 'number' || typeof value === 'string' || typeof value === 'boolean') {
        return value.toString();
      }

      if (value instanceof Date) {
        return value.toJSON();
      }

      return null;
    }
  }]);

  return HttpClient;
}();

exports.HttpClient = HttpClient;